import { BehaviorSubject } from 'rxjs';
import { ArrayCheckboxOptions } from './component-option/arrayCheckbox.model';

export class DuplicateDataValidation {
	[key: string]: DDVBehaviour;
}

export class DDVModel {
	excludedValue: string;
	existingValues: string[];

	constructor(excludedValue: string = null, existingValues: string[] = []) {
		this.excludedValue = excludedValue;
		this.existingValues = existingValues;
	}
}

export class DDVBehaviour extends BehaviorSubject<DDVModel> {
	constructor() {
		super(new DDVModel());
	}
}

export class FieldModel {
	DataType: string;
	SubDataType?: string;
	DisplayText: string;
	Name: string;
	UIControl?: string;
	UIOptions?: UIOptions;
	UIEvents?: any;
	path?: string;
	options?: any[];
	hidden?: boolean;
	required?: boolean;
	disabled?: boolean;
	description?: string;
	customClass?: string;
	Conditionally?: any;
	Visible?: any;
	Disabled?: any;
	isRequired?: any;
	child?: any;
	childFormBuilderConfig: any;
	ButtonText?: string;
	extraData?: any;
	defaultValue?: any;
}

class UIOptions {
	Url?: string;
	SearchFunction?: any;
	Mapper?: any;
	FilterName?: string;
	OptionsMapper?: any;
	LoadFromServer?: boolean;
	ShowClearButton?: boolean;
	OptionLabel?: string;
	OptionValue?: string;
	optionText?: string;
	optionValue?: string;
	placeholder?: string;
	singleSelectMode?: boolean;
	Display?: string;
	ShowFilter?: boolean;
	IsInputGroup?: boolean;
	GroupElement?: InputGroupOptions;
	showLabel?: boolean;
	customTemplate?: boolean;
	customTemplateOptions?: CustomTemplateOptions;
	DisplayInputField?: boolean;
	suffix?: string;
	prefix?: string;
	min?: number;
	max?: number;
	step?: number;
	readonly?: boolean;
	tableConfig?: TableConfig;
	filters?: any;
	counterLabel?: string;
	PickListOptions?: any;
	SelectChips?: any;
	CalendarComponent?: any;
	SwitchComponentOptions?: any;
	ArrayFieldOptions?: any;
	PasswordField?: any;
	CustomInput?: any;
	hideLabel?: boolean;
	validators?: any[];
	validatorsOptions?: {
		[option: string]: any;
	};
	selectedValues?: any[];
	componentOptions: ComponentOptions;
}

export class ComponentOptions {
	arrayCheckbox?: ArrayCheckboxOptions;
}

class CustomTemplateOptions {
	fieldContainerClass?: string;
	descriptionContainerClass?: string;
	fieldElementClass?: string;
	customActionsClass?: string;
}

export class TableConfig {
	isReorderable?: boolean;
	hasCounterInfo?: boolean;
	headerColumns?: string[];
	parentHeaders?: any[];
	childHeaders?: any[];
	childForm?: any;
	displayField?: string;
	hideAddButton?: boolean;
	emptyMessage?: string;
	hideSearch?: boolean;
	searchPlaceholder?: string;
}

class InputGroupOptions {
	Type: 'left' | 'right' | 'both';
	LeftElement?: ChildGroupOptions;
	RightElement?: ChildGroupOptions;
}

class ChildGroupOptions {
	icon?: string;
	text?: string;
}

export const FieldTypes = {
	AUTOCOMPLETE: 'Autocomplete',
	DROPDOWN: 'Dropdown',
	MULTISELECT: 'MultiSelect',
	PICKLIST: 'PickList'
};

export const FormControlArrayValues = [FieldTypes.AUTOCOMPLETE, FieldTypes.MULTISELECT, FieldTypes.PICKLIST];

export class FormFieldModel {
	simpleField?: boolean;
	key?: string;
	path?: string;
	label?: string;
	hidden?: boolean;
	customClass?: string;
	child?: FormFieldModel[][];
}
